import React, { useEffect } from "react";
import { Button, Grid, Typography, Paper } from "@material-ui/core";
import LocalMallOutlinedIcon from "@material-ui/icons/LocalMallOutlined";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import styles from "../../../styles/global-styles.js";
import { SiteService } from "../../../services/site.service.js";
import { customDate } from "../../../_utils/utils.js";
import AddSite from "../modals/AddSite.jsx";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert.js";

const useStyles = makeStyles((theme) => ({
  title: { color: "#1C2668", fontWeight: 600 },
  rightButton: styles.buttonRightHeader,
  label: styles.label,
  chip: styles.chip,
  table: {
    minWidth: 700,
  },
  form: {
    width: "auto", // Fix IE 11 issue.
    height: 280,
    marginTop: theme.spacing(1),
  },
  paper: {
    background: "white",
    marginTop: 30,
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    width: "auto",
    height: "auto",
    padding: "10px 0",
    minHeight: 100,
    "&:hover": {
      backgroundColor: "#ccebff !important",
      cursor: "pointer",
    },
  },
  siteIcon: {
    padding: 12,
    background: "#13b1f4",
    borderRadius: 16,
    width: 58,
    height: 50,
  },
}));

const Site = ({ addAlert, detailAlert, history: { push } }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [siteArray, setSiteArray] = React.useState([]);

  useEffect(() => {
    getSites();
  }, []);

  const getSites = async () => {
    try {
      const { data } = await SiteService.getSitesWithUsersActive();
      console.log("data", data);
      setSiteArray(data);
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msgs,
      });
    }
  };

  const redirectToSite = (url) => push(url);

  const handleOnClose = () => {
    setOpenDialog(false);
  };

  const handleSiteCreated = (siteCreated) => {
    addAlert({ showAlert: true });
    setOpenDialog(false);
    if (siteCreated) {
      getSites();
      detailAlert({
        severity: "success",
        message: "Sucursal dada de altsa exitosamente",
      });
    } else {
      detailAlert({
        severity: "error",
        message: "Error al agregar nuevo sucursal",
      });
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h4" component="h4" className={classes.title}>
            Sucursales
          </Typography>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() => setOpenDialog(true)}
            variant="contained"
            color="primary"
            endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
          >
            Nueva sucursal
          </Button>
        </Grid>
      </Grid>

      <Grid style={{ marginTop: theme.spacing(5) }}>
        {siteArray.length > 0 &&
          siteArray.map((site) => (
            <Paper
              key={site.id}
              elevation={3}
              className={classes.paper}
              onClick={() =>
                redirectToSite(`/dashboard/sucursales/id/${site.id}`)
              }
            >
              <LocalMallOutlinedIcon
                className={classes.siteIcon}
                fontSize="small"
                color="secondary"
              />
              <div style={{ maxWidth: 200 }}>
                <Typography variant="h6" className={classes.title}>
                  {site.name}
                </Typography>
                <Typography>{site.direction}</Typography>
              </div>
              <div>
                <Typography variant="subtitle1" className={classes.title}>
                  {site.cp}
                </Typography>
                <Typography>Código Postal</Typography>
              </div>
              <div>
                <Typography variant="subtitle1" className={classes.title}>
                  {site.serie}
                </Typography>
                <Typography>Serie factura</Typography>
              </div>
              <div>
                <Typography variant="subtitle1" className={classes.title}>
                  {site.users?.length}
                </Typography>
                <Typography># de empleados</Typography>
              </div>
              <div>
                <Typography variant="subtitle1" className={classes.title}>
                  {customDate(site.updatedAt)}
                </Typography>
                <Typography>Último inventario</Typography>
              </div>
            </Paper>
          ))}
      </Grid>
      {openDialog && (
        <AddSite
          onClose={handleOnClose}
          open={openDialog}
          siteCreated={handleSiteCreated}
        />
      )}
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(Site);
